import * as React from 'react';
import s from './AppHeader.scss';
import { withInjectedRootStore, RootStore } from 'providers';
import { Button, Heading, Text } from '@wix/design-system';
import classNames from 'classnames';
import { Template, Theme } from 'enums';
import { Trans, useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';
import { Logo } from './Logo';
import { EditorXBanner } from './EditorXBanner/EditorXBanner';

const themeHeaderConfig = {
  [Theme.AdvancedPlans]: {
    title: 'app.header.anonymous.title',
    subtitle: 'app.header.anonymous.subtitle',
  },
  [Theme.WixStudio]: {
    title: 'app.header.anonymous.title',
    subtitle: 'app.header.anonymous.subtitle',
  },
  [Theme.EditorX]: {
    title: 'app.editorx.header.anonymous.title',
    subtitle: 'app.editorx.header.anonymous.subtitle',
  },
  [Theme.Dayful]: {
    title: 'app.dayful.header.anonymous.title',
    subtitle: 'app.dayful.header.anonymous.subtitle',
    shouldAddWixHeader: true,
  },
};
export interface AnonymousHeaderProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const AnonymousHeaderComp: React.FC<AnonymousHeaderProps> = (props) => {
  const {
    rootStore: {
      appStore: {
        shouldShowEditorXBanner,
        removeUnloadListener,
        getSignInRedirectionLink,
      },
    },
  } = props;

  // we don't want anonymus users to get popup in any case
  removeUnloadListener();
  const { t } = useTranslation();
  const { theme, template } = usePageModeContext();

  const { title, subtitle, shouldAddWixHeader } = themeHeaderConfig[theme];

  const getStartedKey = t(
    template === Template.Grid
      ? 'app.header.anonymous.advanced.get_started'
      : 'app.header.anonymous.get_started',
  );

  return (
    <div>
      {shouldAddWixHeader && (
        <header className={classNames(s.root)} data-hook='loggedin-header'>
          <div className={s.wixHeader}>
            <Logo />
          </div>
        </header>
      )}
      {shouldShowEditorXBanner && <EditorXBanner />}
      <>
        <div
          className={classNames(s.anonymousCta, theme)}
          data-hook='anonymous-header'
        >
          <Heading
            appearance='H1'
            className={classNames(s.anonymousTitle, theme)}
            dataHook='page-title'
          >
            {t(title)}
          </Heading>
          <Text
            tagName='p'
            weight='normal'
            dataHook='page-subtitle'
            className={classNames(s.anonymousSubtitle, theme)}
          >
            <Trans i18nKey={subtitle}>
              sub <br /> title
            </Trans>
          </Text>
          <div className={classNames(s.ctaButtonContainer, s.newTabs, theme)}>
            <Button
              size='large'
              dataHook='get-started'
              skin='premium'
              className={classNames(s.ctaButton, theme)}
            >
              <a
                href={getSignInRedirectionLink()}
                className={classNames(s.anonymusLink, theme)}
              >
                {getStartedKey}
              </a>
            </Button>
          </div>
        </div>
      </>
    </div>
  );
};

export const AnonymousHeader = withInjectedRootStore(
  withExperiments(AnonymousHeaderComp),
);
